import { render, staticRenderFns } from "./TransportManagement.vue?vue&type=template&id=cd45d868&scoped=true&"
import script from "./TransportManagement.vue?vue&type=script&lang=js&"
export * from "./TransportManagement.vue?vue&type=script&lang=js&"
import style0 from "./TransportManagement.vue?vue&type=style&index=0&id=cd45d868&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd45d868",
  null
  
)

export default component.exports